import { defineStore } from 'pinia'
import { nextTick, shallowRef, triggerRef } from 'vue'
import { v5, v4 } from 'uuid'
import { isError, isPlainObject } from 'lodash-es'

/**
 * @typedef {Object} Message
 * @property {String} type one of [info, error]
 * @property {String} message
 */

const ns = {
  info: v4(),
  error: v4(),
  success: v4(),
}

/**
 *
 */
export const useMessageStack = defineStore('messagestack', () => {
  const stack = shallowRef(new Map())

  async function push(m = null) {
    await nextTick()
    let msg = { type: 'info', message: null }
    switch (true) {
      case isError(m):
        msg = { type: 'error', message: m.message }
        break
      case isPlainObject(m):
        msg = m
        break
      default:
        msg.message = m
    }
    if (msg.message === null) {
      return
    }

    // Неизвестный тип не должен ронять uuid.v5 — берем namespace info
    const id = v5(msg.message, ns[msg.type] || ns.info)

    if (stack.value.has(id)) {
      const v = stack.value.get(id)
      msg = { ...v, count: ++v.count }
    } else {
      msg.count = 1
    }
    stack.value.set(id, msg)
    triggerRef(stack)
  }

  /**
   *
   * @param {String} id uuid v5
   */
  function close(id) {
    if (!stack.value.has(id)) {
      return
    }
    stack.value.delete(id)
    triggerRef(stack)
  }

  return {
    stack,
    push,
    close,
  }
})
